module.exports = __webpack_public_path__ + "static/secondTile-460dcfdd3f5661d3e83bb7953610f70e.jpeg";